import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAdmin } from '../../context/AdminContext';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Protected route component for admin pages
 * Redirects to login if not authenticated
 * Redirects to home if authenticated but not an admin
 */
const AdminRoute: React.FC = () => {
  const { currentUser } = useAuth();
  const { isAdmin, isLoading, checkAdminStatus } = useAdmin();
  const location = useLocation();

  useEffect(() => {
    if (currentUser && !isAdmin && !isLoading) {
      checkAdminStatus();
    }
  }, [currentUser, location.pathname]);

  if (!currentUser) {
    // Redirect to login which will redirect to main CoinTracking
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Verifying admin access...
        </Typography>
      </Box>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
